import axios from "axios";

const baseUrl = axios.create({
  baseURL: "https://api.shuf.co.il/",
});

export default baseUrl;
